import React from "react";
import {
  withStyles,
  makeStyles,
  useTheme,
  createStyles,
  Theme,
  WithStyles,
} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Typography, Grid } from "@material-ui/core";

import AppContext from "../../AppContext";
import CartTable from "./CartTable";
import CartCard from "./CartCard";
import { useStripe } from "@stripe/react-stripe-js";

import SweetAlert from "react-bootstrap-sweetalert";
import Chip from "@material-ui/core/Chip";
import Snackbar from "@material-ui/core/Snackbar";

import DoneIcon from "@material-ui/icons/Done";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

import alertstyles from "assets/jss/elite-feats-cms/views/sweetAlertStyle";
import TextField from "@material-ui/core/TextField";
import assessmentNames from "./stripe_helpers/assessmentNames";
import assessmentTitles from "./stripe_helpers/assessmentTitles";
import assessmentIcons from "./stripe_helpers/assessmentIcons";
import CartLoading from "./CartLoading";
import axios from "axios";
import { withRouter, RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";

const styles = (theme: Theme) =>
  createStyles({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  ...alertstyles,
});
function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
interface DialogTitleProps extends WithStyles<typeof styles> {
  children?: React.ReactNode;
  onClose?: () => void;
  id?: string;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) =>
  createStyles({
  root: {
    padding: theme.spacing(2),
  },
  }))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) =>
  createStyles({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
  }))(MuiDialogActions);

interface CartProps extends RouteComponentProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

function CustomizedDialogs(props: CartProps): React.ReactElement {
  const { t } = useTranslation();
  const classes = useStyles() as Record<string, string>;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => {
    props.setOpen(false);
  };

  const [alert, setAlert] = React.useState<React.ReactElement | null>(null);
  const [total, setTotal] = React.useState(0);

  const warningWithConfirmMessage = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("shop:cart.clearAllItemsFromCart")}
        onConfirm={() => handleClear()}
        onCancel={() => {
          hideAlert2();
        }}
        confirmBtnCssClass={classes.button + " " + classes.danger}
        cancelBtnCssClass={classes.button + " "}
        confirmBtnText={t("shop:cart.clear")}
        cancelBtnText={t("shop:cart.cancel")}
        showCancel
      >
        {t("shop:cart.areYouSureRemoveAllItems")}
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    props.setOpen(false);
    setAlert(null);
  };
  const hideAlert2 = () => {
    setAlert(null);
  };

  const handleClear = () => {
    let currentCart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;
    for (let item in currentCart) {
      currentCart[item] = 0;
    }

    localStorage.setItem("cart", JSON.stringify(currentCart));
    cartContext.setCart(currentCart);

    hideAlert();
  };
  const calculateTotal = () => {
    let cart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;

    let subtotal = 0;

    for (let item in cart) {
      if (item[0] === "m") {
        let cost = cart[item] * 50;
        subtotal += cost;
      } else if (item[0] === "t") {
        let cost = cart[item] * 20;
        subtotal += cost;
      }
    }

    setTotal(subtotal);
  };

  const cartContext = React.useContext(AppContext);
  const [cartItems, setCartItems] = React.useState<boolean>(false);
  React.useEffect(() => {
    let cart = cartContext.cart;
    let hasItems = false;
    for (let item in cart) {
      if (cart[item]) {
        hasItems = true;
      }
    }
    setCartItems(hasItems);
  }, [cartContext.cart]);
  React.useEffect(() => {
    if (coupon === "TEST21") {
      setTotal(0);
    }
  });
  const stripe = useStripe();

  const handleCheckout = async () => {
    props.setOpen(false);
    setOpenLoad(true);
    let cart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;
    for (let item in cart) {
      if (!cart[item]) {
        delete cart[item];
      }
    }
    let line_items = Object.keys(cart).map((item: string) => {
      let price = 0;
      if (item[0] === "m") {
        price = 5000;
      } else if (item[0] === "t") {
        price = 2000;
      }
      if (cart[item]) {
        return {
          quantity: cart[item],
          price_data: {
            currency: "usd",
            unit_amount: price,
            product_data: {
              name: assessmentTitles[item],
              description: assessmentNames[item],
              images: [assessmentIcons[item]],
            },
          },
        };
      }
    });

    async function getSession() {
      const res = await axios.post<{ sessionId: string }>(
        "/api/stripe/create-checkout-session",
        line_items,
        {
          headers: {
            "auth-token": localStorage.getItem("token"),
          },
        }
      );

      return res;
    }

    if (coupon === "TEST21") {
      axios
        .post("/api/stripe/test-discount", line_items, {
          headers: {
            "auth-token": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          setOpenLoad(false);
          props.history.push("/admin/checkout-success");
        });
    } else {
      const response = await getSession();
      const { sessionId } = response.data;
      const { error } = await stripe!.redirectToCheckout({
        sessionId,
      });

      if (error) {
        console.log(error);
      }
    }
  };

  const [value, setValue] = React.useState("");
  const [coupon, setCoupon] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openLoad, setOpenLoad] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };
  const handleDelete = () => {
    setValue("");
    setCoupon("");
    calculateTotal();
  };

  const handleCloseAlert = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  // Cart item handlers for mobile cards
  const handleRemoveItem = (item: string) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("shop:cart.removeItemFromCartTitle")}
        onConfirm={() => {
          let currentCart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;
          currentCart[item] = 0;
          localStorage.setItem("cart", JSON.stringify(currentCart));
          cartContext.setCart(currentCart);
          hideAlert2();
        }}
        onCancel={() => hideAlert2()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
        cancelBtnCssClass={classes.button + " "}
        confirmBtnText={t("shop:cart.remove")}
        cancelBtnText={t("shop:cart.cancel")}
        showCancel
      >
        {t("shop:cart.confirmRemoveItemText")}
      </SweetAlert>
    );
  };

  const handleIncrementItem = (item: string) => {
    let currentCart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;
    currentCart[item] += 1;
    localStorage.setItem("cart", JSON.stringify(currentCart));
    cartContext.setCart(currentCart);
  };

  const handleDecrementItem = (item: string) => {
    let currentCart = JSON.parse(localStorage.getItem("cart") as string) as Record<string, number>;
    if (currentCart[item] > 1) {
      currentCart[item] -= 1;
      localStorage.setItem("cart", JSON.stringify(currentCart));
      cartContext.setCart(currentCart);
    }
  };

  return (
    <div>
      <Dialog
        maxWidth={isMobile ? "xs" : "lg"}
        fullScreen={isMobile}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {t("shop:cart.yourShoppingCart")}
        </DialogTitle>
        <DialogContent
          dividers
          style={{
            paddingLeft: isMobile ? 8 : 16,
            paddingRight: isMobile ? 8 : 16,
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                marginBottom: 15,
              }}
            >
              {coupon.length ? (
                <div>
                  <span style={{ marginRight: 10 }}>
                    {t("shop:cart.couponsApplied")}:{" "}
                  </span>
                  <Chip
                    icon={<DoneIcon style={{ color: "#fff" }} />}
                    label={coupon}
                    onDelete={handleDelete}
                    style={{ background: "#4caf50", color: "#fff" }}
                  />
                </div>
              ) : null}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                justifyContent: isMobile ? "flex-start" : "flex-end",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Typography
                align={isMobile ? "left" : "right"}
                style={{
                  fontSize: isMobile ? 18 : 20,
                }}
              >
                <span
                  style={{
                    borderRadius: 5,
                    padding: isMobile ? 8 : 10,
                    paddingRight: isMobile ? 12 : 15,
                    paddingLeft: isMobile ? 12 : 15,
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ marginRight: 5 }}>
                    {t("shop:cart.total")}:{" "}
                  </span>
                  <span style={{}}>&#36; {total.toFixed(2)}</span>
                </span>
              </Typography>{" "}
            </Grid>
          </Grid>

          {isMobile ? (
            <div style={{ marginTop: 16 }}>
              {Object.keys(cartContext.cart).map((item: string, index: number) => {
                return cartContext.cart[item] ? (
                  <CartCard
                    key={index}
                    item={item}
                    quantity={cartContext.cart[item]}
                    onRemove={() => handleRemoveItem(item)}
                    onIncrement={() => handleIncrementItem(item)}
                    onDecrement={() => handleDecrementItem(item)}
                  />
                ) : null;
              })}
            </div>
          ) : (
            <CartTable total={total} setTotal={setTotal} />
          )}
        </DialogContent>
        {cartItems ? (
          <DialogActions
            style={{
              paddingTop: isMobile ? 12 : 15,
              paddingBottom: isMobile ? 12 : 15,
              paddingLeft: isMobile ? 8 : 24,
              paddingRight: isMobile ? 8 : 24,
              display: "flex",
            }}
          >
            <Grid container spacing={isMobile ? 1 : 0}>
              <Grid
                item
                xs={12}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "stretch" : "flex-start",
                  alignItems: "center",
                  marginBottom: isMobile ? 8 : 0,
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? 8 : 0,
                }}
              >
                <TextField
                  id="standard-"
                  label={t("shop:cart.coupon")}
                  size="small"
                  variant="outlined"
                  value={value}
                  onChange={handleChange}
                  fullWidth={isMobile}
                />
                <Button
                  autoFocus
                  onClick={() => {
                    if (value === "TEST21") {
                      setCoupon(value);
                      setValue("");
                      setTotal(0);
                    } else {
                      setOpen(true);
                      setCoupon("");
                      setValue("");
                      calculateTotal();
                    }
                  }}
                  variant="outlined"
                  fullWidth={isMobile}
                  style={{ marginLeft: isMobile ? 0 : 10 }}
                >
                  {t("shop:cart.apply")}
                </Button>
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "stretch" : "flex-end",
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? 8 : 0,
                }}
              >
                <Button
                  autoFocus
                  onClick={() => {
                    warningWithConfirmMessage();
                  }}
                  variant="outlined"
                  fullWidth={isMobile}
                  style={{ marginRight: isMobile ? 0 : 5 }}
                >
                  {t("shop:cart.clearCart")}
                </Button>
                <Button
                  autoFocus
                  onClick={() => handleCheckout()}
                  color="primary"
                  variant="outlined"
                  fullWidth={isMobile}
                  style={{
                    marginLeft: isMobile ? 0 : 5,
                    marginRight: isMobile ? 0 : 5,
                  }}
                >
                  {t("shop:cart.proceedToCheckout")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        ) : null}

        {alert}
        <Snackbar
          open={open}
          autoHideDuration={2000}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity="error">
            {t("shop:cart.invalidCoupon")}
          </Alert>
        </Snackbar>
      </Dialog>

      <CartLoading open={openLoad} setOpen={setOpenLoad} />
    </div>
  );
}

export default withRouter(CustomizedDialogs);
